import classNames from 'classnames';
import { MouseEvent } from 'react';

import { useGenerateUrl } from './QuoteRepriceLink';

interface QuoteRepriceIconProps {
  externalQuoteId: string;
  linkClassName?: string;
  iconClassName?: string;
  onLinkClicked?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

export function QuoteRepriceIcon({
  externalQuoteId,
  linkClassName,
  iconClassName,
  onLinkClicked,
}: QuoteRepriceIconProps) {
  const generateUrl = useGenerateUrl(externalQuoteId);
  return (
    <a
      href={generateUrl()}
      className={classNames('ms-1', linkClassName)}
      data-e2e="quote-reload-url"
      onClick={onLinkClicked}
    >
      <i className={classNames('icon icon-sm', iconClassName)}>launch</i>
    </a>
  );
}
